import { COMPANY_TYPE_DISPLAY } from 'src/data/context-options.ts';
import type { Demographics } from 'src/types/types.ts';

/** Reihenfolge + Labels der dezent ausgespielten Demografie-Angaben.
 * Gemeinsame Quelle für Ergebnisseite und PDF, damit beide identisch bleiben. */
export const DEMOGRAPHIC_FIELDS: { key: keyof Demographics; label: string }[] = [
  { key: 'type', label: 'Institut' },
  { key: 'size', label: 'Größe' },
  { key: 'role', label: 'Position' }
];

export type DemographicItem = { label: string; value: string };

/** Beschriftete, nicht-leere Demografie-Angaben in fester Reihenfolge.
 * Leere oder nur aus Whitespace bestehende Felder werden weggelassen.
 * Institutstypen werden in ihre Nominativ-Anzeigeform übersetzt (die
 * gespeicherten Werte sind Dativ-Fragmente aus dem Kontext-Schritt). */
export function demographicItems(context?: Demographics): DemographicItem[] {
  if (!context) return [];
  return DEMOGRAPHIC_FIELDS.map((f) => {
    const raw = context[f.key]?.trim();
    const value = f.key === 'type' && raw ? (COMPANY_TYPE_DISPLAY[raw] ?? raw) : raw;
    return { label: f.label, value };
  }).filter((i): i is DemographicItem => !!i.value);
}
